import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Escolaridad } from 'src/app/interfaces/escolaridad';
import { Response } from 'src/app/interfaces/response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EscolaridadService {

  private baseApiUrl = environment.baseApi + '/privado/escolaridad';

  constructor(private httpClient: HttpClient) { }

  async obtenerEscolaridadPorIdCandidato(idCandidato: number){
    return await this.httpClient.get<Response>(`${this.baseApiUrl}/${idCandidato}`).toPromise();
  }

  registrarEscolaridad(idCandidato:number, body: Escolaridad): Observable<Response> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<Response>(`${this.baseApiUrl}/${idCandidato}`, body, { headers });
  }

  actualizarEscolaridad(body: Escolaridad): Observable<Response> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.put<Response>(`${this.baseApiUrl}`, body, { headers });
  }

  eliminarEscolaridadPorId(idCandidato: number, idEscolaridad: number): Observable<Response> {
    return this.httpClient.delete<Response>(`${this.baseApiUrl}/${idCandidato}/${idEscolaridad}`);
  }
}
